import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import type { Tournament } from '@swiss-magic/shared-types';

// Shared delete-confirm dialog used by the dashboard card and the
// tournament hub. Controlled via `target`: non-null opens it.

interface Props {
  target: Tournament | null;
  onCancel: () => void;
  onConfirm: () => void;
}

export function DeleteTournamentDialog({ target, onCancel, onConfirm }: Props) {
  const { t } = useTranslation('director');
  return (
    <Dialog open={target !== null} onOpenChange={(open) => !open && onCancel()}>
      <DialogContent data-testid="delete-confirm-dialog">
        <DialogHeader>
          <DialogTitle>{t('dashboard.delete_dialog.title')}</DialogTitle>
          <DialogDescription>
            {t('dashboard.delete_dialog.body', { name: target?.name ?? '' })}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            variant="outline"
            data-testid="cancel-delete-button"
            onClick={onCancel}
          >
            {t('dashboard.delete_dialog.cancel')}
          </Button>
          <Button
            variant="destructive"
            data-testid="confirm-delete-button"
            onClick={onConfirm}
          >
            {t('dashboard.delete_dialog.confirm')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
